export const NODE_NAME = 'video';
